module.exports = __webpack_public_path__ + "img/hero-2027.2531264b.png";